import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  &:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border-top: ", ";\n  display: flex;\n  padding: ", " ", ";\n  text-transform: none;\n\n  &:first-child {\n    margin-top: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { color } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { Paragraph } from '@scp/ui-shared/components/typography';
var E2E_SUFFIX = '-select-menu-header';
var Header = styled(Paragraph).attrs({
  noMargin: true,
  as: 'h3'
})(_templateObject(), function (props) {
  return props.topBorder ? "1px solid ".concat(color.border) : 'none';
}, baselineToPx(2), baselineToPx(4), baselineToPx(2), baselineToPx(2));
var Label = styled(Paragraph).attrs({
  as: 'span',
  noMargin: true,
  medium: true
})(_templateObject2(), ellipsis(), baselineToPx(3));
var ItemIcon = styled(Icon).attrs({
  size: 20,
  color: 'currentColor'
})(_templateObject3(), baselineToPx(2));
export var SelectMenuHeader = function SelectMenuHeader(_ref) {
  var iconName = _ref.iconName,
      children = _ref.children,
      dataE2e = _ref.dataE2e,
      topBorder = _ref.topBorder;
  return React.createElement(Header, {
    topBorder: topBorder,
    "data-e2e": getE2eLabel(children, E2E_SUFFIX, dataE2e)
  }, iconName && React.createElement(ItemIcon, {
    name: iconName
  }), React.createElement(Label, null, children));
};